import styled from 'styled-components';

import { gradient } from '@/styles/shared';

export const HeaderWrapper = styled.div`
  position: relative;
  padding: 20px;
  margin-bottom: 150px;

  @media ${({ theme }) => theme.media.tablet} {
    padding: 0;
    margin-bottom: 150px;
  }

  h1 {
    position: absolute;
    background: ${gradient};
    width: max-content;
    color: white;
    border-radius: 6px;
    padding: 15px 30px 15px 60px;
    font-size: 36px;
    bottom: -30px;
    left: 5px;
    z-index: 3;

    @media ${({ theme }) => theme.media.tablet} {
      font-size: 60px;
      padding: 25px 50px 22px 100px;
      bottom: -60px;
      left: -40px;
    }
  }
`;

export const ImageWrapper = styled.div`
  position: relative;
  margin: 0 auto;

  img {
    min-height: 220px;
    object-fit: cover;
    position: relative;
    z-index: 2;
    max-width: 85vw;
  }

  &::after {
    content: '';
    position: absolute;
    top: -60px;
    right: -35px;
    z-index: 1;
    border-radius: 6px;
    background: ${gradient};
    width: 44px;
    height: 86px;

    @media ${({ theme }) => theme.media.tablet} {
      height: 165px;
      width: 88px;
    }
  }
`;

export const Description = styled.p`
  position: absolute;
  font-family: Roboto, Helvetica, sans-serif;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  margin-top: 57px;
  left: 0;

  @media ${({ theme }) => theme.media.tablet} {
    margin-top: 70px;
    width: 100%;
  }
`;
